import styled from 'styled-components';
import { space, layout } from 'styled-system';
import { StyledProps } from 'types/styles';

interface Props extends StyledProps {
  image?: string;
}

export const Wrapper = styled.div<Props>`
  display: flex;
  height: 100%;
  ${space}
`;

export const FormWrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;

  ${space}
  ${layout}
`;

export const BgImageWrapper = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${props => props.image});
  width: 100%;
  height: 100%;
  max-height: 100vh;
  background-size: cover;
  background-position: center;
`;
